import {createSlice} from "@reduxjs/toolkit";

const initialScholarSynopsysesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  scholarSynopsysForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const scholarSynopsysesSlice = createSlice({
  name: "scholarSynopsyses",
  initialState: initialScholarSynopsysesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getScholarSynopsysById
    scholarSynopsysFetched: (state, action) => {
      state.actionsLoading = false;
      state.scholarSynopsysForEdit = action.payload.scholarSynopsysForEdit;
      state.error = null;
    },
    // findScholarSynopsyses
    scholarSynopsysesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createScholarSynopsys
    scholarSynopsysCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.scholarSynopsys);
    },
    // updateScholarSynopsys
    scholarSynopsysUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.schSynopsysId === action.payload.scholarSynopsys.schSynopsysId) {
          return action.payload.scholarSynopsys;
        }
        return entity;
      });
    },
    // deleteScholarSynopsys
    scholarSynopsysDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.schSynopsysId !== action.payload.schSynopsysId);
    },
    // deleteScholarSynopsyses
    scholarSynopsysesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.schSynopsysId)
      );
    },
  }
});
